








































import { defineComponent, toRefs, PropType, computed, ref, watch } from '@vue/composition-api';
import { RejectInfo, AdgroupFormData, ACTION_TYPE, CampaignFormData, CreateMode } from '@tt4b/ttam-enums';
import { useAuditInfo, useStdAdgroupCbo, useAdgroupCommonAlertInfo, useValidateU18 } from '@tt4b/ttam-hooks';
import { i18n } from './../../../i18n';
import ALink from '@/components/common/a-link/a-link.vue';
import { useAssetLocationValidSattus, useTtpCloverLocationValidStatus } from '../location/hooks';
const name = 'ttam-adgroup-alert-compose';
const ALERT_TYPE_WEIGHT = {
  error: 1,
  warning: 2,
  info: 3,
};
export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    originFormData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    rejectInfo: {
      type: Object as PropType<RejectInfo>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: () => ACTION_TYPE.CREATE,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, createMode, rejectInfo, campaignData, originFormData } = toRefs(props);
    const { isAppealing } = useAuditInfo({ rejectInfo });
    const { isCBO, isCboSamePromotionType } = useStdAdgroupCbo({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });

    const { adgroupAlertInfo, changeHasAlertErrorShow } = useAdgroupCommonAlertInfo();
    const { isAssetLocationInvalid } = useAssetLocationValidSattus({ adgroupData, campaignData });
    const { isTtpCloverLocationInvalid } = useTtpCloverLocationValidStatus({ originAdgroupData: originFormData });
    const isLocationInvalid = computed(() => isTtpCloverLocationInvalid.value || isAssetLocationInvalid.value);

    const { isCloseLoopOnlyUsU18Limit, isShowLimitU18InterestBanner } = useValidateU18({
      adgroupFormData: originFormData,
      campaignFormData: campaignData,
    });

    const alertConfig = computed(() => {
      let config = [
        ...adgroupAlertInfo.value,
        {
          // 为了更好地保护用户隐私，欧洲和英国的用户总数必须增加到1000人以上
          text: i18n.t('adgroup_edit_clover_illegal_tip'),
          type: 'warning',
          show: createMode.value === ACTION_TYPE.EDIT && adgroupData.value.euUvLegal === false,
          linkText: i18n.t('common_learn_more'),
          linkUrl: 'https://ads.tiktok.com/help/article/eea-ch-uk-market-audience-size-threshold-for-ad-group',
        },
        {
          //  新增adgroup编辑场景下申诉中的alert
          text: i18n.t('module_can_not_edit_cuase_appealing_alert'),
          type: 'warning',
          show: createMode.value === ACTION_TYPE.EDIT && isAppealing.value,
        },
        {
          //  新增 cbo 复制场景下 promotionType 不一致的 alert
          text: i18n.t('cbo_copy_different_optimization_location_adg_reset_ad'),
          type: 'warning',
          show:
            createMode.value === CreateMode.COPY &&
            isCBO.value &&
            !isCboSamePromotionType(adgroupData.value.externalType, originFormData.value.externalType),
        },
        {
          // 定向地区已经无效且不可再选
          text: i18n.t('module_adgroup_disable_edit_delivery_policy_alert'),
          type: 'error',
          show: createMode.value === ACTION_TYPE.EDIT && isLocationInvalid.value,
        },
        {
          // 存量广告，only us + 选了13-17，要给banner提示
          text: i18n.t('adgroup_update_impact_tips'),
          type: 'info',
          // 编辑 复制都需要
          show:
            createMode.value !== CreateMode.CREATE &&
            (isCloseLoopOnlyUsU18Limit.value || isShowLimitU18InterestBanner.value),
          closable: true,
          linkText: i18n.t('adgroup_update_impact_learn_more'),
          linkUrl: 'https://ads.tiktok.com/help/article/about-advertising-to-people-under-the-age-of-18',
          linkIcon: true,
        },
      ];
      config.sort((a, b) => ALERT_TYPE_WEIGHT[a.type] - ALERT_TYPE_WEIGHT[b.type]);
      return config;
    });
    const hasErrorAlertShowFlag = computed(() => alertConfig.value.some(v => v.type === 'error' && Boolean(v.show)));
    watch(
      hasErrorAlertShowFlag,
      newVal => {
        if (newVal) {
          changeHasAlertErrorShow(true);
        } else {
          changeHasAlertErrorShow(false);
        }
      },
      {
        immediate: true,
      },
    );
    const handleLinkClick = function () {
      emit('link-click');
    };
    return {
      name,
      alertConfig,
      handleLinkClick,
      isAppealing,
    };
  },
});
